import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { BOX_PRICE, BOX_MAX_VALUE, BOX_MIN_VALUE, BOX_MAX_CREDIT, euro } from "../lib/box";

export const BoxInfoAccordion = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-3 rounded-2xl border border-electric/30 bg-electric/5" data-testid="box-info-accordion">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        data-testid="box-info-toggle"
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-2 px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-electric"
      >
        Clicca qui per info pagamenti e spedizione
        <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} strokeWidth={2} />
      </button>
      {open && (
        <ul className="space-y-2 border-t border-electric/20 px-5 pb-4 pt-3 text-xs leading-relaxed text-ink-soft" data-testid="box-info-content">
          <li>• L'abbonamento parte dal giorno in cui effettui il primo pagamento.</li>
          <li>• Ogni mese (o ogni 2 mesi, in base alla tua scelta) i {euro(BOX_PRICE)} vengono addebitati automaticamente sulla tua carta <strong className="text-ink">3 giorni prima</strong> della data di partenza del box.</li>
          <li>• Il pacco parte entro <strong className="text-ink">2–3 giorni lavorativi</strong> dall'addebito e arriva all'indirizzo che hai indicato.</li>
          <li>• Paghi sempre {euro(BOX_PRICE)} fissi e riempi il box con prodotti fino a {euro(BOX_MAX_VALUE)} di valore di listino (minimo {euro(BOX_MIN_VALUE)}). Se il valore è tra {euro(BOX_MIN_VALUE)} e {euro(BOX_PRICE)}, la differenza (massimo {euro(BOX_MAX_CREDIT)}) diventa credito sul tuo account.</li>
          <li>• Puoi cambiare i prodotti, la frequenza o sospendere l'abbonamento in qualsiasi momento dalla tua area personale.</li>
        </ul>
      )}
    </div>
  );
};
